<template>
  <v-container class="background py-10">
    <v-row>
      <v-col sm="12" cols="12">
        <div class="about_title my-3">
          {{ about.title }}
        </div>
        <div v-for="(line, i) in about.text" :key="i" class="about_text my-4">
          {{ line }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "About",

  data: () => ({
    about: lang.home.about,
  }),
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background-color: map-get($theme-colors, "dark-blue");
}

.about_title {
  color: white;
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
}

.about_text {
  color: white;
  font-family: "Roboto" !important;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
}
</style>
